import { MY_ACCOUNT_URL } from '../../util/urls';
import { updateUserDetails } from '../../redux/actions/authenticationActions';

const LANGUAGE_ID = localStorage.getItem('language')
  ? localStorage.getItem('language')
  : '1';

//Action Types
export const ADD_MYACCOUNT = 'ADD_MYACCOUNT';

//Export Actions
export function addMyAccount(myaccount) {
  return {
    type: ADD_MYACCOUNT,
    myaccount,
  };
}

export function submitFormRequest(
  firstName,
  lastName,
  phoneNumber,
  Email,
  address,
  city,
  state,
  zipcode,
  username,
  changePassword,
  newPassword,
  confirmPassword,
  userId,
  tokenId,
  jwt
) {
  const body = Object.assign(
    {},
    {
      userid: userId,
      email: Email,
      fname: firstName,
      lname: lastName,
      address: address,
      city: city,
      state: state,
      zipcode: zipcode,
      phone: phoneNumber,
      mobile: phoneNumber,
      preferred_language: 0,
    },
    changePassword !== ''
      ? {
          curpwd: changePassword,
          newpwd: newPassword,
          conpwd: confirmPassword,
        }
      : {},
    { languageid: LANGUAGE_ID }
  );

  return dispatch => {
    return fetch(MY_ACCOUNT_URL + 'tokenId/' + tokenId, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + btoa(jwt),
      },
      body: JSON.stringify(body),
    })
      .then(res => (res ? res.json() : {}))
      .then(data => {
        const { UserAccountDetails } = data.DataResponse || {};
        if (UserAccountDetails) {
          dispatch(updateUserDetails(UserAccountDetails));
        }

        return dispatch(AddMyacconnt(data.DataResponse || {}));
      });
  };
}

export function AddMyacconnt(accountDetails) {
  const { Status = '', msg = '', UserAccountDetails = {} } = accountDetails;
  return {
    type: ADD_MYACCOUNT,
    status: Status,
    message: msg,
    data: UserAccountDetails,
  };
}



// WEBPACK FOOTER //
// ./src/views/myaccount/actions.js